<ion-row class="ion-no-padding ion-align-items-center ion-justify-content-center">
  <ion-col
    *ngIf="showPhoto"
    size="1"
    class="ion-no-padding"
    [ngClass]="isDeactivated && 'opacity-50'"
    (click)="detailsEvent.emit($event)"
    pointer
  >
    <ion-avatar margin-auto>
      <img
        [src]="photoUrl ? photoUrl : 'assets/svg/avatar-white.svg'"
        (error)="photoUrl = 'assets/svg/avatar-white.svg'"
      />
    </ion-avatar>
  </ion-col>

  <ion-col
    [size]="showPhoto ? 10 : 11"
    class="ion-no-padding"
    [ngClass]="{ 'opacity-50 line-through': isDeactivated }"
    (click)="detailsEvent.emit($event)"
    pointer
  >
    <ion-row class="ion-no-padding ion-align-items-center ion-justify-content-center">
      <ion-col size="6">
        <h3 regular class="text-primary-dark"> {{ title }} </h3>
      </ion-col>

      <ion-col size="6">
        <h3 regular class="text-primary-dark"> {{ subTitle }} </h3>
      </ion-col>
    </ion-row>
  </ion-col>

  <ion-col size="1" class="ion-no-padding">
    <ion-icon
      pointer
      size="large"
      src="assets/svg/ellipsis-vertical.svg"
      button
      (click)="editButtonEvent.emit($event)"
    ></ion-icon>
  </ion-col>
</ion-row>
<div class="divider"> </div>
